import { render, staticRenderFns } from "./radioButton.vue?vue&type=template&id=45dd876d&scoped=true&"
import script from "./radioButton.vue?vue&type=script&lang=js&"
export * from "./radioButton.vue?vue&type=script&lang=js&"
import style0 from "./radioButton.vue?vue&type=style&index=0&id=45dd876d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd876d",
  null
  
)

export default component.exports